import Loadable from "components/Loadable";
import {lazy} from "react";
import SettingBase from "pages/setting/SettingBase";
const BusinessDetails = Loadable(lazy(() => import('pages/setting/business-details/businessDetails')));
const RolesAccess = Loadable(lazy(() => import('pages/setting/roles-permissions/roles-accesses')));

const Setting = {
    path: 'setting',
    element: <SettingBase />,
    children: [
        {
            path: '',
            element: <BusinessDetails />
        },
        {
            path: 'business',
            element: <BusinessDetails />
        },
       
        {
            path: 'roles-accesses',
            element: <RolesAccess />
        },
       
    ]}
export default Setting;
